var _readingHistoryPanelArticle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useMountEffect } from "@react-hookz/web";
import { isToday, isYesterday } from "date-fns";
import groupBy from "lodash/groupBy";
import React from "react";
import { graphql, readInlineData } from "react-relay";
import { parseRouteType, useSdkContext } from "~/components/contexts";
import { formatGroupDate } from "./helpers";
import { useReadingHistoryOperations } from "./hooks";
import { ReadingHistoryActionMenu } from "./reading-history-action-menu";
import { Container, EmptyContainer, HeaderTitle, ItemButton, ItemTitle, Loading, PlainTextButton, Section, SectionHeader, SectionItem, StyledReadingHistoryEmptyIcon, Title } from "./styles";
export const ReadingHistoryPanel = ({
  state
}) => {
  const {
    currentPageType,
    handleRoutePush,
    handleTrackGA,
    handleTrackGA4,
    user
  } = useSdkContext();
  const {
    clearReadingHistory
  } = useReadingHistoryOperations();
  const groupedReadingHistory = Object.entries(groupBy(state.result, item => formatGroupDate(item.createdAt)));
  useMountEffect(() => {
    handleTrackGA({
      action: "My Account/Overlay/Reading History/Impression",
      category: "My Account",
      label: ""
    });
    handleTrackGA4({
      action: "imp",
      category: "readinghistory",
      subcategory: ""
    });
  });
  return /*#__PURE__*/React.createElement(ReadingHistoryActionMenu, {
    "data-qa": "reading-history-panel"
  }, ({
    bindTrigger,
    isCurrentItem
  }) => {
    const renderEmptyMessage = () => {
      const message = user ? "Your recently viewed stories will appear here. This allows us to give you a more personalised experience." : "By signing up as a registered user, your recently viewed stories will appear here. This allows us to give you a more personalised experience.";
      return /*#__PURE__*/React.createElement(EmptyContainer, {
        "data-qa": "render-empty-message"
      }, message, /*#__PURE__*/React.createElement(StyledReadingHistoryEmptyIcon, null));
    };
    const renderList = () => {
      const formatDisplayGroupDate = groupDate => {
        const date = new Date(groupDate);
        if (isToday(date)) return "Today";
        if (isYesterday(date)) return "Yesterday";
        return groupDate;
      };
      const renderItem = item => {
        var _article$socialHeadli;
        const article = readInlineData(_readingHistoryPanelArticle !== void 0 ? _readingHistoryPanelArticle : (_readingHistoryPanelArticle = require("../../../../queries/__generated__/readingHistoryPanelArticle.graphql"), _readingHistoryPanelArticle.hash && _readingHistoryPanelArticle.hash !== "af787a050af248c5e8bd042565039780" && console.error("The definition of 'readingHistoryPanelArticle' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _readingHistoryPanelArticle), item.article);
        return /*#__PURE__*/React.createElement(SectionItem, {
          key: item.entityUuid,
          "data-qa": "render-item"
        }, /*#__PURE__*/React.createElement(ItemTitle, {
          onClick: () => {
            var _article$application;
            void handleTrackGA4({
              action: "click",
              category: "readinghistory",
              customized_parameters: {
                action_type: "read",
                article_id: article.entityId
              },
              subcategory: ""
            });
            handleTrackGA({
              action: "My Account/Overlay/Reading History/Read",
              category: "My Account",
              label: article.entityId
            });
            void handleRoutePush(article.urlAlias, {
              applicationId: (_article$application = article.application) === null || _article$application === void 0 ? void 0 : _article$application.entityUuid,
              entityId: article.entityId,
              entityUuid: article.entityUuid,
              query: {
                campaign: "reading_history",
                module: "my_account_overlay",
                pgtype: currentPageType
              },
              type: parseRouteType(article.__typename)
            });
          }
        }, (_article$socialHeadli = article.socialHeadline) !== null && _article$socialHeadli !== void 0 ? _article$socialHeadli : article.headline), /*#__PURE__*/React.createElement(ItemButton, _extends({
          "aria-label": "more action",
          disableRipple: true
        }, bindTrigger(item), {
          $isActive: isCurrentItem(item)
        }), /*#__PURE__*/React.createElement(MoreHorizIcon, {
          color: "inherit"
        })));
      };
      return groupedReadingHistory.map(([groupDate, items]) => /*#__PURE__*/React.createElement(Section, {
        key: groupDate
      }, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(HeaderTitle, null, formatDisplayGroupDate(groupDate)), /*#__PURE__*/React.createElement(PlainTextButton, {
        onClick: () => void clearReadingHistory(groupDate)
      }, "Clear")), items.map(item => renderItem(item))));
    };
    const render = () => {
      const isEmptyReadingHistory = groupedReadingHistory.length === 0;
      switch (state.status) {
        case "not-executed":
          return /*#__PURE__*/React.createElement(Loading, {
            color: "inherit"
          });
        case "loading":
          if (!isEmptyReadingHistory) {
            return;
          }
          return /*#__PURE__*/React.createElement(Loading, {
            color: "inherit"
          });
        case "success":
        case "error":
          return isEmptyReadingHistory ? renderEmptyMessage() : renderList();
      }
    };
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Title, null, "Recently Viewed"), render());
  });
};
ReadingHistoryPanel.displayName = "ReadingHistoryPanel";